import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useAuth } from '@app/api/auth/useAuth';
import { ResendButton } from '@shared/ui/buttons';
import Note from '@shared/ui/messages/Note';

const COOLDOWN_DURATION = 360; // seconds
const STORAGE_KEY = 'resendCooldowns';

function getCooldowns() {
  try {
    return JSON.parse(localStorage.getItem(STORAGE_KEY)) || {};
  } catch {
    return {};
  }
}

function saveCooldown(userId, endTime) {
  const cooldowns = getCooldowns();
  if (endTime) {
    cooldowns[userId] = endTime;
  } else {
    delete cooldowns[userId];
  }
  localStorage.setItem(STORAGE_KEY, JSON.stringify(cooldowns));
}

function getInitialExpiredAt(userId) {
  const endTime = getCooldowns()[userId];
  if (endTime > Date.now()) return new Date(endTime).toISOString();
  if (endTime) saveCooldown(userId, null);
  return null;
}

export default function EditMemberResend({ data }) {
  const { t } = useTranslation();
  const { resendActivation } = useAuth();
  const [expiredAt, setExpiredAt] = useState(() =>
    getInitialExpiredAt(data.id),
  );
  const [isLoading, setIsLoading] = useState(false);

  async function handleResend() {
    setIsLoading(true);
    try {
      if (await resendActivation({ email: data.email })) {
        const endTime = Date.now() + COOLDOWN_DURATION * 1000;
        saveCooldown(data.id, endTime);
        setExpiredAt(new Date(endTime).toISOString());
      }
    } finally {
      setIsLoading(false);
    }
  }

  return (
    <Note
      marginBottom
      type="warning"
      title={t('activation')}
      content={t('activation_note')}
    >
      <ResendButton
        expiredAt={expiredAt}
        isLoading={isLoading}
        onResend={handleResend}
      />
    </Note>
  );
}
